import * as ActionTypes from "../constants/ActionTypes";
import {delve} from "../util/util";

// **************************************************************************************************************
export const propertiesReducer = (state = {}, action) => {

    switch (action.type) {
        case ActionTypes.CART_PUT_FORM_DATA_SUCCESS:
            const newState = Object.assign({}, state);
            if (delve(action, 'response.result.projectPassword')) {
                newState.projectPassword = null;
                newState.projectPasswordInCart = delve(action, 'response.result.projectPassword');
            }
            return newState;
        case ActionTypes.SELECT_CART_PROPERTY:
            return Object.assign({}, state, {[action.key]: action.selected})
        default:
            return state
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/Properties.js
 **/